import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=70764463"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=70764463&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports